import type { ErrorNotificationRepository } from '@/domains/ui/errorNotification.repository';
import { BaseNotificationService } from './baseNotification.service';

/**
 * Servicio específico para notificaciones de error usando SweetAlert2
 * Cumple con SRP: única responsabilidad es mostrar errores al usuario
 * Usa servicio base para eliminar duplicación de configuración
 */
class SweetAlertErrorService
  extends BaseNotificationService
  implements ErrorNotificationRepository
{
  /**
   * Muestra una notificación de error al usuario
   * @param message - Descripción del error a mostrar
   */
  async showError(message: string): Promise<void> {
    await this.showNotification(message, BaseNotificationService.CONFIGS.ERROR);
  }
}

export const errorNotificationService = new SweetAlertErrorService();
